import { Navigate } from 'react-router-dom';
import { routes } from '@const/routes';
import PaymentsLayout from '@layouts/payments';
import { useIgamingAccess } from '@hooks/helpers/useIgamingAccess';

/**
 * Route guard for `/igaming`. Mirrors the header menu rule (an individual
 * account that is receiving iGaming payouts) so the page can't be reached by
 * typing the URL when the menu entry is hidden. Business accounts and
 * payout-less individuals are redirected home.
 */
const IgamingGuard = () => {
    const { hasAccess, isResolving } = useIgamingAccess();

    if (isResolving) return null;
    if (!hasAccess) return <Navigate to={routes.dashboard} replace />;

    return <PaymentsLayout layoutType="igaming" />;
};

export default IgamingGuard;
